export default __webpack_public_path__ + "static/media/Head_5_Ear_1_C4.5e6a1fe6.svg";